import { useRoutes } from 'react-router-dom';
import WarehouseRoutes from 'routes/WarehouseRoutes';
import LoginRoutes from 'routes/LoginRoutes';
import AuthenticationRoutes from 'routes/AuthenticationRoutes';
import AppRoutes from 'routes/AppRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    AppRoutes,
    WarehouseRoutes,
    LoginRoutes,
    AuthenticationRoutes,
  ]);
}
